import React from 'react';
const LandingPage = () =>
 <div  className="container text-muted">
   <div className="container-fluid" style={{marginTop:"80px"}} >
        <h1 className="text-muted">Case Study</h1>
        <p >
          When you study from our website you can learn the some basic rules and other information of the programming languages, that are use in the world. 
          Education is the process of facilitating learning or the acquisition of knowledge, skills, values, beliefs, and habits.<br/> Educational methods include storytelling, discussion, teaching, training, and directed research.In most regions, education is compulsory up to a certain age.
          so We can start learning from the programming languages that are used in now a days, Like 
          </p>
          <dt>
            <dl>Javascript</dl>
            <dl>Swift</dl>
            <dl>Python</dl>
          </dt>
          <dt>
            <h1 className="text-muted">Other Platefrom of Artificail Inteligence is:</h1>
            <dl>Data Science</dl>
            <dl>Big Data</dl>
            <dl>Machine Learning</dl>
            <dl>Data WareHouse</dl>
          </dt>
       
      </div>
      </div>
export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Landing/index.js